import { useMemo, FC } from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { useTranslation } from '../i18n';
import { scorePassword } from '../validators/password';
import Badge from './Badge';

const useStyles = makeStyles(() =>
  createStyles({
    password: {
      display: 'block',
      padding: '5px',
      textAlign: 'center',
    },
  })
);

type Status = 'error' | 'important' | 'info' | 'inverse' | 'success' | 'warning';

type Props = {
  password: string;
};

/**
 * @summary Плашка, которая сообщает пользователю степень надёжности пароля.
 * Использует внутри себя компонент Badge.
 *
 * @param password - Пароль, введённый пользователем.
 *
 * @see Badge
 */
const BadgePassword: FC<Props> = ({ password }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const [secure, badge]: [string, Status] = useMemo(() => {
    const level = scorePassword(password);

    if (level > 75) {
      return [t('Secure'), 'success'];
    }
    if (level > 50) {
      return [t('Safe'), 'warning'];
    }
    return [t('Weak'), 'error'];
  }, [password]);

  return (
    <Box mb={1}>
      <Badge title={secure} status={badge} className={classes.password} />
    </Box>
  );
};

export default BadgePassword;
